import { FormControl, Autocomplete, TextField, createFilterOptions } from '@mui/material';

import type { IAutocompleteProps } from '../../../types';

/**
 * This component renders Autocomplete component to select values
 * @param {IAutocompleteProps} props AutoComplete Props
 * @returns {JSX.Element} a  Autocomplete component.
 */
const AutocompleteInput = (props: IAutocompleteProps) => {
  const handleInputChange = (newVal) => {
    const val = newVal ? JSON.stringify([newVal.code]) : null;
    props.code ? props.handleChange(props.code, val) : props.handleChange(newVal);
  };

  const isValueMismatch = (props.value as { code: string })?.code === 'NA';

  return (
    <FormControl fullWidth>
      <Autocomplete
        id={props.code ?? 'autocomplete'}
        size={props.size}
        options={props.data}
        onChange={(_, newVal) => handleInputChange(newVal)}
        getOptionLabel={(option) =>
          props.showCode ? `${option.name} (${option.code})` : option.name
        }
        filterOptions={createFilterOptions({ trim: true })} // Create a custom filter that trims whitespace
        disableClearable={props.disableClear}
        value={props?.value}
        disabled={props.disabled}
        data-testid={props.id}
        className={isValueMismatch ? 'autocomplete-value-mismatch' : undefined}
        renderInput={(params) => (
          <TextField {...params} label={props.label} error={!!isValueMismatch} />
        )}
      />
    </FormControl>
  );
};

export default AutocompleteInput;
